import React from 'react';
import styled from 'styled-components';
import { theme } from '../../styled';
const getStatusColor = (status) => {
    switch (status) {
        case 'TO_DECIDE':
        case 'APPROVE_TO_DECIDE':
        case 'ENQUEUED':
        case 'APPROVE_ENQUEUED':
        case 'REVIEW_TO_DECIDE':
            return theme.yellow;
        case 'SIGNED':
        case 'APPROVE_CONSENTED':
        case 'SUCCESS':
        case 'REVIEW_POSITIVE':
            return theme.vgreen;
        case 'APPROVE_REJECTED':
        case 'REJECTED':
        case 'FAILED':
        case 'REVIEW_NEGATIVE':
            return theme.darkRed;
        case 'REJECTED_BY_OTHER':
        case 'CANCELED':
            return theme.navyBlue;
        default:
            return theme.vDarkGray;
    }
};
const StatusStyle = styled.span `
  display: flex;
  color: ${(props) => getStatusColor(props.status)};
`;
const Status = ({ className, translations, status }) => (React.createElement(StatusStyle, { className: `Status ${className || ''}`, status: status }, translations[status]));
export default Status;
